__turbopack_context__.v({
  "accountMenu": "layout-module__sqqsta__accountMenu",
  "accountMenuIcon": "layout-module__sqqsta__accountMenuIcon",
  "accountName": "layout-module__sqqsta__accountName",
  "accountNameButton": "layout-module__sqqsta__accountNameButton",
  "accountWrap": "layout-module__sqqsta__accountWrap",
  "activeLanguage": "layout-module__sqqsta__activeLanguage",
  "cartButton": "layout-module__sqqsta__cartButton",
  "cartDraftThumb": "layout-module__sqqsta__cartDraftThumb",
  "cartIcon": "layout-module__sqqsta__cartIcon",
  "cartMessage": "layout-module__sqqsta__cartMessage",
  "cartPopover": "layout-module__sqqsta__cartPopover",
  "cartProduct": "layout-module__sqqsta__cartProduct",
  "cartRow": "layout-module__sqqsta__cartRow",
  "cartTableHead": "layout-module__sqqsta__cartTableHead",
  "cartTotal": "layout-module__sqqsta__cartTotal",
  "cartWrap": "layout-module__sqqsta__cartWrap",
  "copyright": "layout-module__sqqsta__copyright",
  "divider": "layout-module__sqqsta__divider",
  "footer": "layout-module__sqqsta__footer",
  "footerGroup": "layout-module__sqqsta__footerGroup",
  "footerInner": "layout-module__sqqsta__footerInner",
  "header": "layout-module__sqqsta__header",
  "infoIcon": "layout-module__sqqsta__infoIcon",
  "language": "layout-module__sqqsta__language",
  "logoBlock": "layout-module__sqqsta__logoBlock",
  "logoImage": "layout-module__sqqsta__logoImage",
  "logoLink": "layout-module__sqqsta__logoLink",
  "logoutIcon": "layout-module__sqqsta__logoutIcon",
  "modelIcon": "layout-module__sqqsta__modelIcon",
  "nav": "layout-module__sqqsta__nav",
  "orderIcon": "layout-module__sqqsta__orderIcon",
  "quickSearch": "layout-module__sqqsta__quickSearch",
  "searchClose": "layout-module__sqqsta__searchClose",
  "searchForm": "layout-module__sqqsta__searchForm",
  "searchIcon": "layout-module__sqqsta__searchIcon",
  "searchInput": "layout-module__sqqsta__searchInput",
  "searchOverlay": "layout-module__sqqsta__searchOverlay",
  "searchPanel": "layout-module__sqqsta__searchPanel",
  "searchPanelIcon": "layout-module__sqqsta__searchPanelIcon",
  "searchPanelTop": "layout-module__sqqsta__searchPanelTop",
  "sessionNotice": "layout-module__sqqsta__sessionNotice",
  "studioIcon": "layout-module__sqqsta__studioIcon",
  "topActionButton": "layout-module__sqqsta__topActionButton",
  "topActions": "layout-module__sqqsta__topActions",
  "topBar": "layout-module__sqqsta__topBar",
});
